
import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";
import { encryptAES } from "../../../services/CryptoService";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";


const MembershipTaskListServiceApi = createApi({
    reducerPath: 'MembershipTaskListServiceApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getAccountInformationById: builder.query({
            query: (details) => ({
                url: `/Membership/GetAccountInformationById?id=${encryptAES(details.ipasMemberId)}&id2=${encryptAES(details.taskListId)}`,
                method: 'GET',
            }),

            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllDropDownsForTaskList: builder.query({
            query: () => ({
                url: `/Membership/GetAllDropDownsForTaskList`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllMembershipTaskList: builder.mutation({
            query: (details) => ({
                url: `/Membership/GetAllMembershipTaskList`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        rejectMemberApplication: builder.mutation({
            query: (details) => ({
                url: `/Membership/RejectMemberApplication`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveIndividualMemberClarificationDetails: builder.mutation({
            query: (details) => ({
                url: `/Membership/SaveIndividualMemberClarificationDetails`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        sendPaymentLinkForIndividualMembership: builder.mutation({
            query: (details) => ({
                url: `/Membership/SendPaymentLinkForIndividualMembership`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getTaskListDetailsOfMemberById: builder.query({
            query: (details) => ({
                url: `/Membership/getTaskListDetailsOfMemberById?id=${encryptAES(details.ipasMemberId)}&id2=${encryptAES(details.taskListId)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteTaskListDetailsOfMemberById: builder.query({
            query: (details) => ({
                url: (`/Membership/DeleteTaskListDetailsOfMemberById?id=${encryptAES(details?.id)}&id2=${encryptAES(details?.id2)}&id3=${encryptAES(details?.id3)}&id4=${encryptAES(details?.id4)}`),
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteViewIndivudualMember: builder.mutation({
            query: (details) => ({
                url: '/Membership/DeleteViewIndivudualMember',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetAllReinstatementApplicationsTaskList: builder.mutation({
            query: (details) => ({
                url: `/Membership/GetAllReinstatementApplicationsTaskList`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateApplicationTypeFromTaskList: builder.mutation({
            query: (details) => ({
                url: '/Membership/UpdateApplicationTypeFromTaskList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetAllUpgradeApplicationsTaskList: builder.mutation({
            query: (details) => ({
                url: '/Membership/GetAllUpgradeApplicationsTaskList',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        })
    }),
})

export const {
    useLazyGetAccountInformationByIdQuery,
    useLazyGetAllDropDownsForTaskListQuery,
    useGetAllMembershipTaskListMutation,
    useRejectMemberApplicationMutation,
    useSaveIndividualMemberClarificationDetailsMutation,
    useSendPaymentLinkForIndividualMembershipMutation,
    useLazyGetTaskListDetailsOfMemberByIdQuery,
    useLazyDeleteTaskListDetailsOfMemberByIdQuery,
    useDeleteViewIndivudualMemberMutation,
    useGetAllReinstatementApplicationsTaskListMutation,
    useUpdateApplicationTypeFromTaskListMutation,
    useGetAllUpgradeApplicationsTaskListMutation,

} = MembershipTaskListServiceApi;

export default MembershipTaskListServiceApi;